import React, {Fragment, useEffect, useState} from 'react';

import {UserTypes} from "../DataFunctions/Constants";
import {getUserData} from "../DataFunctions/UserDataFns";
import TableUsers from "root/Tables/TableUsers";
import ModalUser from "root/Modals/ModalUser/ModalUser";
import { ModalUserModes } from "root/Modals/ModalUser/ModalUserConstants" ;
import useModalComponent from "root/Modals/useModalComponent";
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";


const UsersPage = ({selectedUserType, currentName }) =>
{
    const [data, setData] = useState({loading: true, data: []});
    const [renderUserModal, activateUserModal] = useModalComponent( ModalUser ) ;

    useEffect(() =>
    {
        getdata(selectedUserType);
    }, [selectedUserType]);

    const getdata = () =>
    {
        getUserData(+selectedUserType, (data) =>
        {
            if (checkError(data))
            {
                setData({loading: false, data: data.data});
            }
        });
    }

    const buttonElement = (buttonText, clickHandler, disabled) =>
    {
        if (disabled)
        {
            return <button key='b2' id='getButtonReact' disabled type='button' className='btn btn-primary'>{buttonText}</button>;
        }
        else
        {
            return <button key='b1' id='getButtonReact' type='button' className='btn btn-primary' onClick={clickHandler}>{buttonText}</button>;
        }
    }

    const handleCreateNewUser = (e) =>
    {
        activateUserModal({mode: ModalUserModes.CREATE, user_id: null, user_type: +selectedUserType}).then((result) =>
        {
            if (result === 'saved')
            {
                getdata();
            }
        }) ;
    }

    const onClickUser = ({mode, user_id, user_type}) =>
    {
        activateUserModal({mode: mode, user_id: user_id, user_type: +selectedUserType}).then((result) => {
            if (result === 'saved')
            {
                getdata();
            }
        })
    }

    const divElement = () =>
    {
        const disabled = +selectedUserType === 0;
        const shouldShowCreate = +selectedUserType !== UserTypes.LAC;
        const btnText = disabled ? 'Select a User Role to create a new user' : 'Create a new ' + (currentName === '' ? "User" : currentName);

        return (
            <Fragment>
                <BootstrapRow>
                    <BootstrapCol width={12}>
                        <TableUsers data={data.data} loading={data.loading} role_id={+selectedUserType} onClick={onClickUser}/>
                    </BootstrapCol>
                    {shouldShowCreate === true &&  <BootstrapCol width={12}>
                        {buttonElement(btnText, handleCreateNewUser, disabled)}
                    </BootstrapCol> }
                    {renderUserModal()}
                </BootstrapRow>

            </Fragment>
        )
    }

    return (
            divElement()
    )
}

export default UsersPage;
